import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Bluetooth: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m375 405.21c-2.29 0-4.58-.52-6.71-1.58-5.08-2.54-8.29-7.73-8.29-13.42v-255c0-5.68 3.21-10.88 8.29-13.42s11.16-1.99 15.71 1.42l170 127.5c3.78 2.83 6 7.28 6 12s-2.22 9.17-6 12l-170 127.5c-2.65 1.98-5.81 3-9 3zm15-240v195l130-97.5z' />
    <path d='m375 660.21c-2.29 0-4.58-.52-6.71-1.58-5.08-2.54-8.29-7.73-8.29-13.42v-255h30v225l130.22-97.66-104.38-80.46 18.31-23.76 120 92.5c3.71 2.86 5.87 7.29 5.84 11.98s-2.25 9.09-6 11.9l-170 127.5c-2.65 1.98-5.81 3-9 3z' />
    <path d='m214 529.71c-9.94-13.25-7.25-32.06 6-42l146-109.5 18 24z' />
    <path d='m257.5 244.41h30v132.64h-30z' transform='matrix(.61097451 -.79165027 .79165027 .61097451 -139.98 336.6)' />
  </IconBase>
));

Bluetooth.displayName = 'Bluetooth';

export default Bluetooth;
